/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listing_Category_AutomotiveInputs */

const en_listing_category_automotive = /** @type {(inputs: Listing_Category_AutomotiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automotive`)
};

const es_listing_category_automotive = /** @type {(inputs: Listing_Category_AutomotiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automotriz`)
};

const fr_listing_category_automotive = /** @type {(inputs: Listing_Category_AutomotiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automobile`)
};

const de_listing_category_automotive = /** @type {(inputs: Listing_Category_AutomotiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fahrzeuge`)
};

const ja_listing_category_automotive = /** @type {(inputs: Listing_Category_AutomotiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動車`)
};

const zh_listing_category_automotive = /** @type {(inputs: Listing_Category_AutomotiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`汽车`)
};

const ar_listing_category_automotive = /** @type {(inputs: Listing_Category_AutomotiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سيارات`)
};

const id_listing_category_automotive = /** @type {(inputs: Listing_Category_AutomotiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otomotif`)
};

const it_listing_category_automotive = /** @type {(inputs: Listing_Category_AutomotiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motori`)
};

const ru_listing_category_automotive = /** @type {(inputs: Listing_Category_AutomotiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Транспорт`)
};

const pt_listing_category_automotive = /** @type {(inputs: Listing_Category_AutomotiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automóveis`)
};

const ko_listing_category_automotive = /** @type {(inputs: Listing_Category_AutomotiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`자동차`)
};

/**
* | output |
* | --- |
* | "Automotive" |
*
* @param {Listing_Category_AutomotiveInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const listing_category_automotive = /** @type {((inputs?: Listing_Category_AutomotiveInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listing_Category_AutomotiveInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listing_category_automotive(inputs)
	if (locale === "es") return es_listing_category_automotive(inputs)
	if (locale === "fr") return fr_listing_category_automotive(inputs)
	if (locale === "de") return de_listing_category_automotive(inputs)
	if (locale === "ja") return ja_listing_category_automotive(inputs)
	if (locale === "zh") return zh_listing_category_automotive(inputs)
	if (locale === "ar") return ar_listing_category_automotive(inputs)
	if (locale === "id") return id_listing_category_automotive(inputs)
	if (locale === "it") return it_listing_category_automotive(inputs)
	if (locale === "ru") return ru_listing_category_automotive(inputs)
	if (locale === "pt") return pt_listing_category_automotive(inputs)
	return ko_listing_category_automotive(inputs)
});